import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0535ee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-angle-left" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Trailer Solutions", -1))
const _hoisted_4 = {
  key: 0,
  class: "trailer-results-listing"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "h-100 d-flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_list_refresh = _resolveComponent("list-refresh")!
  const _component_ExpandableBadge = _resolveComponent("ExpandableBadge")!
  const _component_NoTrailersAvailable = _resolveComponent("NoTrailersAvailable")!
  const _component_NearbyTrailerResultCard = _resolveComponent("NearbyTrailerResultCard")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar", { 'expanded-list': _ctx.isListExpanded }])
  }, [
    _createVNode(_component_list_refresh, { parentRefreshing: _ctx.isRefreshing }, null, 8, ["parentRefreshing"]),
    _createVNode(_component_ExpandableBadge),
    _createElementVNode("div", {
      class: "sidebar-header",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchExpand && _ctx.switchExpand(...args)))
    }, [
      _createElementVNode("div", {
        class: "icon-container back-button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.navigateToDriverLanding && _ctx.navigateToDriverLanding(...args)), ["stop"]))
      }, _hoisted_2),
      _hoisted_3
    ]),
    (_ctx.shouldHideTrailerListing == false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : (_ctx.noResults)
              ? (_openBlock(), _createBlock(_component_NoTrailersAvailable, { key: 1 }))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.results, (result, index) => {
                  return (_openBlock(), _createBlock(_component_NearbyTrailerResultCard, {
                    key: index,
                    result: result,
                    onSetSelectedResult: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setSelectedResult', $event)))
                  }, null, 8, ["result"]))
                }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["trailer-results-footer sidebar-footer", { 'no-results': _ctx.noResults || _ctx.shouldHideTrailerListing }])
        }, [
          (_ctx.trailerAssociationsEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_fbx_button, {
                  class: "italic",
                  "button-text": _ctx.attachButtonText,
                  theme: "link",
                  onClick: _ctx.navigateToEnterTrailer
                }, null, 8, ["button-text", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}